// ── patchNotesDatabase.js ────────────────────────────────────────────
// Source of truth for versioning and patch notes.
// To publish new patch notes:
//   1. Bump CURRENT_VERSION
//   2. Add a new entry at the TOP of PATCH_NOTES (newest first)
// ────────────────────────────────────────────────────────────────────

export const CURRENT_VERSION = '1.0';

// newest first
export const PATCH_NOTES = [
  {
    version: '1.0',
    label: 'Official Launch',
    date: 'July 6, 2026',
    groups: [
      {
        title: 'YOUR BRAND',
        type: 'new',
        items: [
          { text: 'Brand Selection — Choose from Raw, SmackDown, NXT, WCW, ECW, NXT 2.0, NXT Mutiny, or create your own custom brand with full logo and background support' },
          { text: 'GM Roster — Pick your General Manager from a full cast of WWE personalities, each with their own render and branded identity' },
          { text: '4 Save Slots — Run up to four separate careers simultaneously, each with its own brand, roster, and season history' },
        ],
      },
      {
        title: 'YOUR ROSTER',
        type: 'new',
        items: [
          { text: 'WWE 2K26 & 2K25 — Access 412 and 339 superstars respectively, with full search, filter, and class sorting' },
          { text: 'Draft System — Build your roster through a structured draft, competing against AI-controlled rival GMs' },
          { text: 'Tag Teams & Factions — Form and manage tag teams directly from your active roster' },
          { text: 'Custom Superstars — Create original wrestlers with custom stats, roles, and uploaded renders' },
          { text: 'Free Agent Recruitment — Sign available superstars between shows to strengthen your brand mid-season' },
        ],
      },
      {
        title: 'YOUR SHOWS',
        type: 'new',
        items: [
          { text: 'Weekly Booking — Book matches, promos, and segments every week with full match type and stipulation control' },
          { text: 'Show Flow — Run your show with a full animated sequence featuring your branded background, match results, and title change celebrations' },
          { text: 'PLE Events — Book inter-brand Pay-Per-View events on a dedicated card with their own atmosphere and booking flow' },
          { text: 'Fan & Budget Economy — Every decision impacts your weekly fan count and season standings against rival GMs' },
        ],
      },
      {
        title: 'YOUR STORY',
        type: 'new',
        items: [
          { text: 'Rivalry System — Create feuds between superstars, build heat across multiple weeks, and book the blowoff match' },
          { text: '20 Unique Storylines — From Championship Gold to Betrayal arcs, each with phase-based narrative text that evolves as the rivalry progresses' },
          { text: 'Championships — Assign, defend, and track every title on your brand across the full season and beyond' },
          { text: 'Rivalry History — A permanent record of every concluded feud, outcome, and storyline across your career' },
        ],
      },
      {
        title: 'YOUR GLORY',
        type: 'new',
        items: [
          { text: 'Season Standings — Compete against rival GM brands across the full season for the top spot in the fan rankings' },
          { text: 'Hall of Fame — Induct your most decorated superstars at the end of each season in a dedicated HOF ceremony' },
          { text: 'Trophy System — Earn HOF trophies by hitting rivalry milestones and season objectives' },
          { text: 'Season Recap — A full end-of-season summary covering champions, HOF inductees, and standout moments from your brand' },
        ],
      },
    ],
  },
  // ── Add future versions above this line ─────────────────────────────
];
